module.exports = __webpack_public_path__ + "img/tip-2x.0041c4f6.png";